import React from 'react';
import {TabbedOverviewPage, UsingReportSection} from '../components/OverviewSections.comp';

const AboutReportPage = () => (
    <TabbedOverviewPage
        tabs={[
            {
                label: 'What This Report Tells You',
                content: <UsingReportSection/>,
            },
        ]}
    />
);

export default AboutReportPage;
